import React, { useEffect, useRef } from 'react';

function ArtistFilterPopup({ filters, onFilterChange, onReset, onClose }) {
  const containerRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const filterGroups = [
    {
      id: 'role',
      title: 'Role',
      options: [
        { id: 'singer', label: 'singers' },
        { id: 'music', label: 'music' },
        { id: 'lyrics', label: 'lyrics' },
        { id: 'band', label: 'Bands' },
      ],
    },
    {
      id: 'gender',
      title: 'male or female',
      options: [
        { id: 'Male', label: 'Male' },
        { id: 'Female', label: 'Female' },
        { id: 'Other/Group', label: 'Other/Group' },
      ],
    },
    {
      id: 'tracks',
      title: 'tracks',
      options: [
        { id: '100', label: '100 songs count' },
        { id: 'Other', label: 'Other' },
      ],
    },
  ];

  return (
    <div className="popup-dropdown filter-dropdown" ref={containerRef}>
      <div className="popup-dropdown-header">
        <span className="popup-title">Filters</span>
        <button type="button" className="reset-all-btn" onClick={onReset}>
          Reset All
        </button>
      </div>

      <div className="filter-groups-list">
        {filterGroups.map((group) => (
          <div key={group.id} className="filter-popup-group">
            <div className="filter-group-title">{group.title}</div>
            <div className="filter-group-options">
              {group.options.map((opt) => {
                const isSelected = filters[group.id] === opt.id;
                return (
                  <button
                    key={opt.id}
                    type="button"
                    className={`filter-badge-btn ${isSelected ? 'active' : ''}`}
                    onClick={() => {
                      if (isSelected) {
                        onFilterChange(group.id, null);
                      } else {
                        onFilterChange(group.id, opt.id);
                      }
                    }}
                  >
                    {opt.label}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ArtistFilterPopup;
